import React from 'react';
import PropTypes from 'prop-types';
import Card from './Card';
import './index.scss';

const source = 'gallery-listing';

const MainContent = ({ items }) => (
    <div className="main-content">
        {items.map((item, index) => (
            <Card key={index} item={item} source={source}/>))}
    </div>
);

MainContent.propTypes = {
    items: PropTypes.array
};

export default MainContent;
